/** Breadcrumb / audit id for Assigned Review Task global view. */
export const ASSIGNED_REVIEW_TASK_PAGE_ID = 'GV-QC-REVIEW-001';

/** Tab keys stored in URL and used by table toolbar. */
export const ASSIGNED_REVIEW_TASK_TABS = /** @type {const} */ ({
  NEW: 'NEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
});
